import { render, staticRenderFns } from "./IFReportSidebar.vue?vue&type=template&id=4c3910f4"
import script from "./IFReportSidebar.vue?vue&type=script&lang=js"
export * from "./IFReportSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports